<template>
  <div style="padding-left:5px;padding-right:5px;">
    <ConfirmDialog
      :dialog="showConfirmDelete"
      @modalResult="confirmDeleteFixtureDialogResult"
      title="Delete Fixture"
      :text=getDeleteText()
      yesColor="#f5f5f5"
    >
    </ConfirmDialog>

    <CreateNewEasyFixtureDialog
      :dialog="showCreateNewEasyFixtureDialog"
      @close="closeCreateNewEasyFixtureDialog"
    >
    </CreateNewEasyFixtureDialog>

    <ResetEasyFixtureDialog
      :dialog="showResetEasyFixtureDialog"
      :fixture="fixture"
      @close="closeResetEasyFixtureDialog"
    >
    </ResetEasyFixtureDialog>

    <ModifyEasySubscriptionDialog
      :dialog="showModifyEasySubscriptionDialog"
      :serialNumber="fixture.serialNumber"
      :subscriptionPackage="fixture.subscriptionPackage"
      :subscriptionExpires="getExpiration()"
      :subscriptionExpiresYear="getExpirationYear()"
      :subscriptionExpiresMonth="getExpirationMonth()"
      :subscriptionExpiresDay="getExpirationDay()"
      @close="closeModifyEasySubscriptionDialog"
    >
    </ModifyEasySubscriptionDialog>

    <v-card flat>
      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, showFirstLastPage: true, showCurrentPage: true  }"
        :headers="headers"
        :loading="busy"
        :items="fixtures"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openModifyEasySubscriptionDialog(item)" v-on="on">autorenew</v-icon>
            </template>
            <span>Edit Subscription</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openResetEasyFixtureDialog(item)" v-on="on">undo</v-icon>
            </template>
            <span>Reset Activation Count</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openConfirmDeleteDialog(item)" v-on="on" style="color:red;">delete_forever</v-icon>
            </template>
            <span>Delete Serial Number</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          @click.stop="openCreateNewEasyFixtureDialog()"
          :loading="creatingEasyFixture"
        >
          Create New Fixture
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar
      v-model="alertVisible"
      timeout="10000"
    >
      {{ alertText }}
      <v-btn
        color="pink"
        text
        @click="alertVisible = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import moment from 'moment';
import ConfirmDialog from '../ConfirmDialog.vue';
import CreateNewEasyFixtureDialog from './CreateNewEasyFixtureDialog.vue';
import ResetEasyFixtureDialog from './ResetEasyFixtureDialog.vue';
import ModifyEasySubscriptionDialog from './ModifyEasySubscriptionDialog.vue';

export default {
  components: {
    ConfirmDialog,
    CreateNewEasyFixtureDialog,
    ResetEasyFixtureDialog,
    ModifyEasySubscriptionDialog,
  },

  props: {
    filterSerialNumber: String,
  },

  data() {
    return {
      showCreateNewEasyFixtureDialog: false,
      creatingEasyFixture: false,
      showResetEasyFixtureDialog: false,
      resettingEasyFixture: false,
      showModifyEasySubscriptionDialog: false,
      modifyingEasySubscription: false,

      alertVisible: false,
      alertText: false,

      showConfirmDelete: false,

      options: {},
      busy: false,
      serverItemsLength: 0,
      fixtures: [],
      fixture: {},

      headers: [
        {
          text: 'Serial Number',
          align: 'left',
          sortable: false,
          value: 'serialNumber',
          width: 150,
        },
        {
          text: 'Activation Count',
          align: 'left',
          sortable: false,
          value: 'activationCount',
          width: 150,
        },
        {
          text: 'Subscription Type',
          align: 'left',
          sortable: false,
          value: 'subscriptionPackage',
          width: 150,
        },
        {
          text: 'Subscription Expiration',
          align: 'left',
          sortable: false,
          value: 'subscriptionExpires',
          width: 150,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 150,
        },
      ],
    };
  },

  watch: {
    filterSerialNumber: {
      handler() {
        this.getData();
      },
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  beforeUpdate() {
  },

  updated() {
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/api/v1/ez_get_fixtures/?page=${this.options.page || 1}&filterSerialNumber=${this.filterSerialNumber}`,
      };

      this.fixture = {};
      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.fixtures = res.data.docs.map((cur) => {
            const { createdAt, updatedAt, ...rest } = cur;
            const created = moment(createdAt);
            const updated = moment(updatedAt);
            return Object.assign({}, {
              createdAt: created.local().format('YYYY-MM-DD HH:mm:ss'),
              updatedAt: updated.local().format('YYYY-MM-DD HH:mm:ss'),
            }, rest);
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    filter() {
      this.getData();
    },

    openCreateNewEasyFixtureDialog() {
      console.log('open create');
      this.showCreateNewEasyFixtureDialog = true;
    },

    closeCreateNewEasyFixtureDialog(value) {
      if (value && value.serialNumber) {
        this.creatingEasyFixture = true;

        const options = {
          method: 'post',
          url: '/api/v1/create_ez_fixture',
          data: value,
        };

        this.axios(options)
          .then((res) => {
            this.creatingEasyFixture = false;
            console.log(`... create res ${res.status}`);

            if (res.status === 200) {
              this.alertText = `EZ ADAS fixture ${value.serialNumber} already exists`;
              this.alertVisible = true;
            } else if (res.status === 201) {
              this.alertText = `EZ ADAS fixture ${value.serialNumber} was created`;
              this.alertVisible = true;
            } else {
              this.alertText = 'EZ ADAS fixture creation failed';
              this.alertVisible = true;
            }
          });
      }

      this.showCreateNewEasyFixtureDialog = false;
    },

    openResetEasyFixtureDialog(fixture) {
      console.log('open reset');
      this.fixture = fixture;
      this.showResetEasyFixtureDialog = true;
    },

    closeResetEasyFixtureDialog(value) {
      if (value && value.serialNumber) {
        this.resettingEasyFixture = true;

        const options = {
          method: 'post',
          url: '/api/v1/reset_ez_fixture',
          data: value,
        };

        this.axios(options)
          .then((res) => {
            this.resettingEasyFixture = false;
            console.log(`... reset res ${res.status}`);

            if (res.status === 200) {
              this.alertText = `EZ ADAS fixture ${value.serialNumber} reset`;
              this.alertVisible = true;

              this.getData();
            } else if (res.status === 204) {
              this.alertText = `EZ ADAS fixture ${value.serialNumber} has no activations`;
              this.alertVisible = true;
            }

            this.fixture = {};
          })
          .catch((err) => {
            this.alertText = 'EZ ADAS fixture reset failed';
            this.alertVisible = true;
          });
      }

      this.showResetEasyFixtureDialog = false;
    },

    openModifyEasySubscriptionDialog(fixture) {
      console.log('open modify subscription');
      this.fixture = fixture;
      this.showModifyEasySubscriptionDialog = true;
    },

    closeModifyEasySubscriptionDialog(value) {
      if (value && value.serialNumber) {
        this.modifyingEasySubscription = true;

        const options = {
          method: 'post',
          url: '/api/v1/ez_create_subscription',
          data: value,
        };

        this.axios(options)
          .then((res) => {
            this.modifyingEasySubscription = false;
            this.fixture = {};

            console.log(`... update subscription res ${res.status}`);

            if (res.status === 200) {
              this.alertText = `EZ ADAS ${value.serialNumber} subscription updated`;
              this.alertVisible = true;

              this.getData();
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.alertText = `EZ ADAS fixture ${value.serialNumber} does not exist`;
              this.alertVisible = true;
            } else {
              this.alertText = 'EZ ADAS update subscription failed';
              this.alertVisible = true;
            }
          });
      }

      this.showModifyEasySubscriptionDialog = false;
    },

    pad(someNumber, size = 2) {
      let num = someNumber.toString();
      while (num.length < size) {
        num = `0${num}`;
      }
      return num;
    },

    getExpirationYear() {
      if (this.fixture && this.fixture.subscriptionExpires) {
        const e = this.fixture.subscriptionExpires;
        const p = e.split('/');

        let y = p[2];

        if (this.fixture.subscriptionExpires === 'N/A') {
          y = new Date().getFullYear() + 1;
        }

        return y;
      }
      return 2078;
    },

    getExpirationMonth() {
      if (this.fixture && this.fixture.subscriptionExpires) {
        const e = this.fixture.subscriptionExpires;
        const p = e.split('/');

        let m = p[0];

        if (this.fixture.subscriptionExpires === 'N/A') {
          m = new Date().getMonth() + 1;
        }

        return this.pad(m);
      }
      return 12;
    },

    getExpirationDay() {
      if (this.fixture && this.fixture.subscriptionExpires) {
        const e = this.fixture.subscriptionExpires;
        const p = e.split('/');

        let d = p[1];

        if (this.fixture.subscriptionExpires === 'N/A') {
          d = new Date().getDate();
        }

        return this.pad(d);
      }
      return 21;
    },

    getExpiration() {
      const y = this.getExpirationYear();
      const m = this.getExpirationMonth();
      const d = this.getExpirationDay();

      console.log(`getExpiration returns ${y}-${m}-${d}`);

      return `${y}-${m}-${d}`;
    },

    getDeleteText() {
      return (`Are you sure you want to delete ${this.fixture.serialNumber}?`);
    },

    openConfirmDeleteDialog(fixture) {
      this.fixture = fixture;
      this.showConfirmDelete = true;
    },

    confirmDeleteFixtureDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/api/v1/delete_ez_fixture',
          data: {
            serialNumber: this.fixture.serialNumber,
          },
        };

        this.axios(options)
          .then((res) => {
            this.showConfirmDelete = false;
            this.fixture = {};

            this.getData();
          });
      } else {
        this.showConfirmDelete = false;
        this.fixture = {};
      }
    },
  },
};
</script>
